const isJsdomEnvironment = (): boolean =>
  globalThis.navigator?.userAgent.toLowerCase().includes('jsdom') ?? false;

export const redirectTo = (path: string): void => {
  if (globalThis.window === undefined) return;

  // jsdom does not implement full-document navigation via location.assign/href.
  // In tests we model redirects by updating URL history.
  if (isJsdomEnvironment()) {
    window.history.replaceState({}, '', path);
    return;
  }

  window.location.assign(path);
};
